import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import React, { useMemo, useState } from 'react';
import { collapsedAtom, openKeysAtom } from '@/layouts/BasicLayout/store';
import { useMenus } from '@/routes';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import { useLocation, useNavigate } from 'react-router-dom';
const MenuItem = _Menu.Item;
const {
  SubMenu
} = _Menu;
const Wrapper = styled.div`
  overflow: auto;
  height: 100%;

  :global(.arco-menu-item-inner > a::after),
  :global(.arco-menu-item > a::after) {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  :global(.arco-menu-inline-header) {
    font-weight: 500;
  }
`;
export function NavMenus() {
  const location = useLocation();
  const menus = useMenus();
  const [openKeys, setOpenKeys] = useAtom(openKeysAtom);
  const [selectedKeys, setSelectedKeys] = useState(() => {
    return [location.pathname];
  });
  const [collapsed] = useAtom(collapsedAtom);
  const navigate = useNavigate();
  const MenuNotes = useMemo(() => {
    return function travel(routes) {
      return routes.map(item => {
        // 1.对group的处理
        if (item.icon) {
          if (item.children && item.children.length > 0) {
            return /*#__PURE__*/React.createElement(SubMenu, {
              key: item.path,
              title: /*#__PURE__*/React.createElement(React.Fragment, null, item.icon, item.name)
            }, travel(item.children));
          } else {
            return null;
          }
        } // 2.对item的处理


        return /*#__PURE__*/React.createElement(MenuItem, {
          key: item.path
        }, item.name);
      });
    }(menus);
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(_Menu, {
    selectedKeys: selectedKeys,
    openKeys: openKeys,
    collapse: collapsed,
    onClickMenuItem: key => {
      setSelectedKeys([key]);
      navigate(key);
    },
    onClickSubMenu: (_, openKeys) => {
      setOpenKeys(openKeys);
    }
  }, MenuNotes));
}